/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_PaletteInputs */

const cs_workflow_palette = /** @type {(inputs: Workflow_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paleta uzlů`)
};

const en_workflow_palette = /** @type {(inputs: Workflow_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node palette`)
};

/**
* | output |
* | --- |
* | "Node palette" |
*
* @param {Workflow_PaletteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_palette = /** @type {((inputs?: Workflow_PaletteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_PaletteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_palette(inputs)
	return cs_workflow_palette(inputs)
});